import { getNextSibling } from "../utils/dom";

export default class FilePicker extends HTMLInputElement {

    constructor() {
        super();

        // Add your code here
    }

    connectedCallback() {

        this.addEventListener("change", this.handleChange);
        
    }

    disconnectedCallback() {

        this.removeEventListener("change", this.handleChange);

    }

    handleChange = e => {
        let fileName = "";

        if (this.files && this.files.length > 1)
            fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
        else if (e.target.value)
            fileName = e.target.value.split('\\').pop();

        if (fileName) {
            this.labelElement.innerText = fileName;
            this.closest(".form-file")?.classList.add("form-file-selected");
        }
    }

    get labelElement() {
        return getNextSibling(this, ".form-file-text");
    }

    attributeChangedCallback(name, oldValue, newValue) {
        
    }

    //static get observedAttributes() { return ['foo']; }

}

customElements.define('file-picker', FilePicker, { extends: 'input' });